__turbopack_context__.v({
  "container": "fZck-q_container",
  "likeButton": "fZck-q_likeButton",
  "likeCount": "fZck-q_likeCount",
});
